import { render, staticRenderFns } from "./BaseNamePreviewFileUploadInput.vue?vue&type=template&id=604ffa22&scoped=true"
import script from "./BaseNamePreviewFileUploadInput.vue?vue&type=script&lang=js"
export * from "./BaseNamePreviewFileUploadInput.vue?vue&type=script&lang=js"
import style0 from "./BaseNamePreviewFileUploadInput.vue?vue&type=style&index=0&id=604ffa22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ffa22",
  null
  
)

export default component.exports